module.exports = __webpack_public_path__ + "static/media/audi_zertifikat_2010_2.cac0c57f.jpg";